import React, { useMemo, useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { CitizenParamList } from '../../../typings/Params';
import { CitizenStatus } from '../../../services/central-api/citizen';
import { useStyles } from 'react-native-unistyles';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import moment from 'moment';
import FilterDatePicker from '../../../components/Filter/components/FilterDateInput';

interface Props {
    filters: CitizenParamList['CitizenManagement'];
    setFilters: React.Dispatch<React.SetStateAction<CitizenParamList['CitizenManagement']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const { theme } = useStyles();
    const navigation = useNavigation<NavigationProp<RouteProp<CitizenParamList, 'CitizenManagement'>>>();

    const [status, setStatus] = useState<CitizenStatus | null>(filters.status ?? null);
    const [createdAtDate, setCreatedAtDate] = useState(filters.createdAt ? new Date(filters.createdAt) : null);
    const [createdAtHour, setCreatedAtHour] = useState(filters.createdAt ? moment(filters.createdAt).format('HH:mm') : '');

    const handleCleanFilter = () => {
        setTextFilter('');
        setStatus(null);
        setCreatedAtDate(null);
        setCreatedAtHour('');
    };

    const handleFilter = () => {
        const formatDateTime = (date: Date | null, time: string) =>
            date ? moment(`${moment(date).format('DD/MM/YYYY')} ${time}`, 'DD/MM/YYYY HH:mm:ss').valueOf() : undefined;
        const createdAt = formatDateTime(createdAtDate, createdAtHour ? `${createdAtHour}:00` : '00:00:00');

        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            status: status ? status : undefined,
            createdAt: createdAt
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            status: status ? status : undefined,
            createdAt: createdAt
        });
    };

    const citizenStatusItems = useMemo(() => {
        return Object.values(CitizenStatus)
            .map((val) => ({
                label: val === 'disabled' ? translate('disabled_alt') : translate(val),
                value: val,
                color: theme.colors.primary['500'],
                textColor: theme.colors.white['500']
            }));
    }, []);

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            <FilterDropdown
                label={translate('status')}
                items={citizenStatusItems}
                zIndex={3}
                value={status}
                setValue={setStatus}
            />

            <FilterDatePicker
                date={createdAtDate}
                onChangeDate={setCreatedAtDate}
                time={createdAtHour}
                onChangeTime={setCreatedAtHour}
                label={translate('createdAt')}
                zIndex={5}
            />
        </Filters>
    );
}

export default Filter;
